// @Utility
import { getStorage, removeStorage } from "@utility/app/storage";
import alertText from "@utility/app/alertText";
import { decryptWithPrefix } from "@utility/app/encrypt";

// JWT & Auth
import { setCustomerToken } from "@core/auth/jwt/jwtService";
import { syncPushAfterLogin } from "@utility/app/webPush";
import jwtDefaultConfig from "@core/auth/jwt/jwtDefaultConfig";

// Redux & Action
import { loadHomeData } from "@core/redux/actions/home/index";
import { setSnackbarData } from "@core/redux/actions/app/snackbar";
import { setStatusSpinner } from "@core/redux/actions/app/spinner";
import { setDataAlert } from "@core/redux/actions/app/alert";
import { setDataPopupContact } from "@core/redux/actions/app/popup";

// Services
import { apiServices, trackCustomerOnline } from "@core/services/appService";

const jwtConfig = { ...jwtDefaultConfig };
const OPEN_AUTHEN = 'app/login/OPEN_AUTHEN';
// const OPEN_REGISTER = 'app/register/OPEN_REGISTER';
// test

function openAuthenApp(data) {
    return {
        type: OPEN_AUTHEN,
        payload: {
            items: data
        }
    }
}

function authentication(dataJson, close) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่..." }));
        apiServices(dataJson, jwtConfig.method_post, jwtConfig.loginEndpoint).then((data) => {
            let snackbarJson = {};
            const { code: statusCode, token } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                setCustomerToken(token);
                syncPushAfterLogin();
                dispatch(loadHomeData());
                snackbarJson = {
                    statusShow: true,
                    statusAlert: "success",
                    titleAlert: "แจ้งเตือน",
                    textAlert: "เข้าสู่ระบบสำเร็จ !"
                };

                trackCustomerOnline()
                dispatch(setSnackbarData(snackbarJson));

                if (close) {
                    close();
                }
            }
            else {
                snackbarJson = alertText(statusCode);
                dispatch(setDataAlert({
                    type: snackbarJson.statusAlert,
                    title: snackbarJson.titleAlert,
                    text: snackbarJson.textAlert,
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
}

// test

// ประกอบข้อมูลสมัครสมาชิก (ใช้ร่วมกันทั้งเส้น register-short และ register-otp/vertify)
function buildRegisterPayload(data, selectBank, dataBankAccountName) {
    let dataJson = {
        "username": data.phone,
        "password": data.phone,
        "affiliate": getStorage("affiliate") ? decryptWithPrefix(getStorage("affiliate")) : "",
        /* ส่งค่าดิบ ห้ามผ่าน decryptWithPrefix เหมือน affiliate
           backend ตัด prefix เองโดยเทียบกับ agent code จริง */
        "partner": getStorage("partner") ? getStorage("partner") : "",
        "refer": getStorage("refer") ?  getStorage("refer") : "",
        "know_web": "",
        "allusion": getStorage("allusion"),
        "bank_account": data.bank_account,
        "bank_name": dataBankAccountName,
        "bank_swift": selectBank,
        "fbc": getStorage("fbclid") ?  getStorage("fbclid") : "",
        "fbc_timestamp": getStorage("fbctimestamp") ?  getStorage("fbctimestamp") : "",
        "keitaro_id": (getStorage("clickid") && !getStorage("platform")) ? getStorage("clickid") : "",
        "voluum_c_id": (getStorage("clickid") && (getStorage("platform") === "voluum")) ? getStorage("clickid") : ""
    }

    if (getStorage("market") && getStorage("market") !== "Null" && getStorage("market") !== "null" && getStorage("market") !== "") {
        dataJson.refer = getStorage("market")
    }

    return dataJson;
}

// ตรวจสอบข้อมูลฟอร์มก่อนยิง API — คืนค่า payload ถ้าผ่าน / คืน null ถ้าไม่ผ่าน (พร้อม alert ให้แล้ว)
function validateRegisterForm(dispatch, data, selectBank) {
    if (selectBank === null) {
        dispatch(setDataAlert({
            type: "warning",
            title: "แจ้งเตือน",
            text: "กรุณาเลือกธนาคารที่ต้องการทำรายการ !",
            action: true,
            redirect: "",
            show: true,
            buttonText: "ตกลง"
        }));
        return null;
    }

    if (data.phone === "" || !data.bank_account) {
        dispatch(setDataAlert({
            type: "warning",
            title: "แจ้งเตือน",
            text: "กรุณากรอกข้อมูล เบอร์โทรศัพท์ และเลขบัญชีธนาคาร !",
            action: true,
            redirect: "",
            show: true,
            buttonText: "ตกลง"
        }));
        return null;
    }

    let dataBankAccountName = "";
    if (data?.bank_account_name !== undefined) {
        if (data?.bank_account_name === "") {
            dispatch(setDataAlert({
                type: "warning",
                title: "แจ้งเตือน",
                text: "กรุณากรอกข้อมูลชื่อบัญชีธนาคาร !",
                action: true,
                redirect: "",
                show: true,
                buttonText: "ตกลง"
            }));
            return null;
        }

        dataBankAccountName = data?.bank_account_name;
    }

    return buildRegisterPayload(data, selectBank, dataBankAccountName);
}

// จัดการผลลัพธ์หลังสมัครสมาชิกสำเร็จ (ใช้ร่วมกันทั้ง 2 เส้น)
function registerSuccess(dispatch, { token, username, passwordCustomer, close }) {
    setCustomerToken(token);
    syncPushAfterLogin();
    dispatch(loadHomeData());
    removeStorage("allusion");

    if (passwordCustomer !== null && passwordCustomer !== undefined) {
        dispatch(setDataAlert({
            type: "success",
            title: "สมัครสมาชิกสำเร็จ",
            text: null,
            action: {
                select: "register",
                username: username,
                password: passwordCustomer
            },
            redirect: "",
            show: true,
            buttonText: null
        }));
    }
    else {
        dispatch(setDataAlert({
            type: "success",
            title: "แจ้งเตือน",
            text: "สมัครสมาชิกสำเร็จ !",
            action: true,
            redirect: "",
            show: true,
            buttonText: "ตกลง"
        }));
    }

    // removeStorage("refer");
    // removeStorage("affiliate");

    if (close) {
        close();
    }

    dispatch(setDataPopupContact(true));
}

function alertByCode(dispatch, statusCode) {
    let dataAlt = alertText(statusCode);
    dispatch(setDataAlert({
        type: dataAlt.statusAlert,
        title: dataAlt.titleAlert,
        text: dataAlt.textAlert,
        action: true,
        redirect: "",
        show: true,
        buttonText: "ตกลง"
    }));
}

function registerCustomer(data, close, selectBank, setShowAccName, onOtpRequired, onError) {
    return dispatch => {
        const dataJson = validateRegisterForm(dispatch, data, selectBank);
        if (dataJson === null) {
            return;
        }

        dispatch(setStatusSpinner({status: true, textProcess: "ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่..."}));

        apiServices(dataJson, jwtConfig.method_post, jwtConfig.registerEndpointShort).then((data) => {
            const { code: statusCode, token, password: passwordCustomer } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                registerSuccess(dispatch, {
                    token,
                    username: dataJson.username,
                    passwordCustomer,
                    close
                });
            }
            else {
                // agent เปิดใช้งาน OTP อยู่ → สลับไปใช้เส้น OTP แทน
                if (statusCode === 94 && onOtpRequired) {
                    onOtpRequired();
                    return;
                }

                if(statusCode === 68) {
                    setShowAccName(true);
                }

                if (!(onError && onError(statusCode) === true)) {
                    alertByCode(dispatch, statusCode);
                }
            }
        });
    }
}

// ขอรหัส OTP ครั้งแรก — ตรวจฟอร์มให้ครบก่อน จะได้ไม่เปลือง SMS ตอนข้อมูลยังไม่พร้อม
// onSuccess(result) รับ { ref, phone, expire_in, expire_at }
function requestRegisterOtp(data, selectBank, onSuccess, onError) {
    return dispatch => {
        const dataJson = validateRegisterForm(dispatch, data, selectBank);
        if (dataJson === null) {
            return;
        }

        const phone = data.phone;

        // ส่งข้อมูลสมัครไปให้ API ตรวจตั้งแต่เส้นนี้ จะได้ไม่เสีย SMS ฟรีตอน vertify ตอบ 14 / 51 / 68
        // ฝั่ง API ฟิลด์พวกนี้เป็นของเสริม (omitempty) — client ที่ยังส่งแค่ phone ก็ยังทำงานเหมือนเดิม
        const dataJsonOtp = {
            phone,
            username: dataJson.username,
            bank_account: dataJson.bank_account,
            bank_name: dataJson.bank_name,
            bank_swift: dataJson.bank_swift
        };

        dispatch(setStatusSpinner({ status: true, textProcess: "กำลังส่งรหัส OTP กรุณารอสักครู่..." }));

        apiServices(dataJsonOtp, jwtConfig.method_post, jwtConfig.registerOtpRequest).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 0 || statusCode === 200) {
                if (onSuccess) {
                    onSuccess(result);
                }
            }
            else if (!(onError && onError(statusCode) === true)) {
                // onError คืน true = จัดการเองแล้ว ไม่ต้องเด้ง alert ซ้ำ
                alertByCode(dispatch, statusCode);
            }
        });
    }
}

// ขอรหัส OTP ซ้ำ — ใช้ ref เดิม รหัสเดิม แต่เวลาหมดอายุขยับใหม่
function resendRegisterOtp(phone, ref, onSuccess, onError) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: "กำลังส่งรหัส OTP กรุณารอสักครู่..." }));

        apiServices({ phone, ref }, jwtConfig.method_post, jwtConfig.registerOtpResend).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 0 || statusCode === 200) {
                if (onSuccess) {
                    onSuccess(result);
                }
            }
            else if (!(onError && onError(statusCode) === true)) {
                alertByCode(dispatch, statusCode);
            }
        });
    }
}

// ยืนยัน OTP + สมัครสมาชิกในขั้นตอนเดียว (เส้นนี้สำเร็จจะได้ code 200 และไม่มี result ห่อ)
function verifyRegisterOtp(data, close, selectBank, setShowAccName, otpData, onError) {
    return dispatch => {
        const dataJson = validateRegisterForm(dispatch, data, selectBank);
        if (dataJson === null) {
            return;
        }

        dataJson.ref = otpData.ref;
        dataJson.otp = otpData.otp;
        dataJson.phone = data.phone;

        dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่..." }));

        apiServices(dataJson, jwtConfig.method_post, jwtConfig.registerOtpVerify).then((data) => {
            const { code: statusCode, token, password: passwordCustomer } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                registerSuccess(dispatch, {
                    token,
                    username: dataJson.username,
                    passwordCustomer,
                    close
                });
            }
            else {
                if (statusCode === 68) {
                    setShowAccName(true);
                }

                if (!(onError && onError(statusCode) === true)) {
                    alertByCode(dispatch, statusCode);
                }
            }
        });
    }
}

function rememberPassword(data, gotoPage) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        apiServices({username: data.username}, jwtConfig.method_post, jwtConfig.rememberPassword).then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const { code: statusCode } = data;

            if (statusCode === 200 || statusCode === 0) {
                dispatch(setDataAlert({
                    type: "success",
                    title:"ขอรหัสผ่านใหม่สำเร็จ",
                    text: "ส่งรหัสผ่านใหม่ ไปยังเบอร์โทรศัพท์ของคุณเเล้ว",
                    action: true,
                    redirect: "",
                    show: true,
                    buttonText: "ตกลง"
                }));

                if (gotoPage) {
                    gotoPage('/');
                }
            }
            else {
                let dataAlt = alertText(statusCode);
                
                dispatch(setDataAlert({
                    type: dataAlt.statusAlert,
                    title: dataAlt.titleAlert,
                    text: dataAlt.textAlert,
                    action: true,
                    redirect: "",
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
}

function loginToken(dataJson) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: "ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่..." }));
        apiServices(dataJson, jwtConfig.method_post, jwtConfig.loginTokenEndpoint).then((data) => {
            let snackbarJson = {};
            const { code: statusCode, token } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                setCustomerToken(token);
                syncPushAfterLogin();
                dispatch(loadHomeData());
                snackbarJson = {
                    statusShow: true,
                    statusAlert: "success",
                    titleAlert: "แจ้งเตือน",
                    textAlert: "เข้าสู่ระบบสำเร็จ !"
                };

                dispatch(setSnackbarData(snackbarJson));
                dispatch(setDataPopupContact(true));

                trackCustomerOnline()
            }
        });
    }
}

export {
    OPEN_AUTHEN,
    // OPEN_REGISTER,
    authentication,
    openAuthenApp,
    registerCustomer,
    requestRegisterOtp,
    resendRegisterOtp,
    verifyRegisterOtp,
    rememberPassword,
    loginToken
}